import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showLoader, hideLoader } from "../redux/actions/LoaderActions"
import ApiServices from "../config/ApiServices"
import { toast } from "react-toastify"
import Loader from "../utils/Loader"
import { Bar, Pie } from "react-chartjs-2"
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { Link } from "react-router-dom"
import BatchGraphStudent from "../graphs/BatchGraphStudent"

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

export default function StudentDashboard(){
    const loading=useSelector((state)=>state.loader.loading)
    const dispatch=useDispatch()
    const [data,setData]=useState({})
    const studentId=sessionStorage.getItem("userId")
    const [marks, setMarks] = useState([]);
    const [averageMarks, setAverageMarks] = useState(0); 

     const getMarks = () => {
            dispatch(showLoader());
            ApiServices.apiRequest("getMarks", { studentId: studentId })
                .then((res) => {
                    if (res.data.success) {
                        setMarks(res.data.data);
                        console.log("marks data is:",res.data.data)
                        if (res.data.data && res.data.data.length > 0) {
                            const total = res.data.data.reduce(
                                (acc, item) => acc + (item?.score ?? 0), 
                                0
                            ); 
                            const avg = total / res.data.data.length;
                            setAverageMarks(avg);
                        } else {
                            setAverageMarks(0);
                        }
                    } else {
                        toast.error(res.data.message);
                    }
                })
                .catch((err) => {
                    toast.error(err?.message || "Something went wrong");
                })
                .finally(() => {
                    dispatch(hideLoader());
                });
        };

    useEffect(()=>{
        dispatch(showLoader())
        ApiServices.apiRequest("studentDashbaord",{studentsId:studentId})
        .then((res) => {
            if (res.data.success) {
                setData(res.data);
                console.log("dashboard data is:",res.data)
            } else {
                console.log(res.data.message);
            }
        })
        .catch((err) => {
            console.log(err)
        })
        .finally(() => {
            dispatch(hideLoader());
        });

        getMarks(); 
    },[])

    return(
     <>
        <div className="container">
          <div className="page-inner">
          {loading ? (
                <Loader />
            ) : (
            <>
                <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                    <h3 className="fw-bold mb-3">Dashboard</h3>
                </div>
                </div>
               <div className="row">
                    <div className="col-sm-6 col-md-4">
                        
                        <div className="card card-stats card-round">
                            <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-icon">
                                <div className="icon-big text-center icon-primary bubble-shadow-small">
                                    <i className="fas fa-book-open" />
                                </div>
                                </div>
                                <div className="col col-stats ms-3 ms-sm-0">
                                <div className="numbers">
                                    <p className="card-category">Batches</p>
                                    <h4 className="card-title">{data?.studenttotalbatchs ?? 0}</h4>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        
                    </div>

                    <div className="col-sm-6 col-md-4">
                        <div className="card card-stats card-round">
                        <div className="card-body">
                            <div className="row align-items-center">
                            <div className="col-icon">
                                <div className="icon-big text-center icon-info bubble-shadow-small">
                                <i className="fas fa-percentage" />
                                </div>
                            </div>
                            <div className="col col-stats ms-3 ms-sm-0">
                                <div className="numbers">
                                <p className="card-category">Percentage</p>
                                <h4 className="card-title">
                                    {(data?.studentPercentage ?? 0).toFixed(1)}
                                </h4>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-4">
                        <div className="card card-stats card-round">
                        <div className="card-body">
                            <div className="row align-items-center">
                            <div className="col-icon">
                                <div className="icon-big text-center icon-success bubble-shadow-small">
                                <i className="fas fa-chart-line" /> 
                                </div>
                            </div>
                            <div className="col col-stats ms-3 ms-sm-0">
                                <div className="numbers">
                                <p className="card-category">Average Marks</p>
                                <h4 className="card-title">{(averageMarks ?? 0).toFixed(1)}</h4>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-round">
                        <div className="card-header">
                            <div className="card-head-row">
                            <div className="card-title">Batch Statistics</div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="chart-container" style={{ minHeight: 375 }}>
                            <div>
                                <BatchGraphStudent studentId={studentId}/>
                            </div>
                            </div>
                            <div id="myChartLegend" />
                        </div>
                        </div>
                    </div>
                </div> 
            </>
            )}
          </div>
        </div>
      </>
    )
}
